import { render, staticRenderFns } from "./ApproveSender.vue?vue&type=template&id=6e6d3ef0"
import script from "./ApproveSender.vue?vue&type=script&lang=js"
export * from "./ApproveSender.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports